import React from 'react';
import ReactDatePicker from 'react-date-picker';
import {
  DateEditor,
  MonthView,
  YearView,
  DecadeView,
  HistoryView,
  DateFormatInput,
  DateFormatSpinnerInput,
  TransitionView,
  MultiMonthView,
  NavBar,
  Footer,
  Clock,
  ClockInput,
  DateField,
  Calendar,
  TimePicker,
  TimeInput
} from 'react-date-picker';

/**
 * @description Works exactly like react-date-picker, with
 *  a few added props :
 * @prop {Boolean} DatePicker - Enables the 'DatePicker' component
 * @prop {Boolean} DateEditor - Enables the 'DateEditor' component
 * @prop {Boolean} MonthView - Enables the 'MonthView' component
 * @prop {Boolean} YearView - Enables the 'YearView' component
 * @prop {Boolean} DecadeView - Enables the 'DecadeView' component
 * @prop {Boolean} HistoryView - Enables the 'HistoryView' component
 * @prop {Boolean} DateFormatInput - Enables the 'DateFormatInput' component
 * @prop {Boolean} DateFormatSpinnerInput - Enables the 'DateFormatSpinnerInput' component
 * @prop {Boolean} TransitionView - Enables the 'TransitionView' component
 * @prop {Boolean} MultiMonthView - Enables the 'MultiMonthView' component
 * @prop {Boolean} NavBar - Enables the 'NavBar' component
 * @prop {Boolean} Footer - Enables the 'Footer' component
 * @prop {Boolean} Clock - Enables the 'Clock' component
 * @prop {Boolean} ClockInput - Enables the 'ClockInput' component
 * @prop {Boolean} DateField - Enables the 'DateField' component
 * @prop {Boolean} Calendar - Enables the 'Calendar' component
 * @prop {Boolean} TimePicker - Enables the 'TimePicker' component
 * @prop {Boolean} TimeInput - Enables the 'TimeInput' component
 * @prop {Boolean} stayOpen - Allows the calender to stay open when blurred. Default : false
 * @prop {Boolean} dark - Gives the calender a dark theme
 */
class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.date_picker_props;
  }

  componentDidMount() {
    if(this.props.dark) {
      $('.ht-date-picker-custom-class').css({
        'background-color': '#1d2228',
        border: '0px'
      });
    }
  }

  render() {
    this.date_picker_props = {
      ...(this.props || {}),
      className: `ht-date-picker-custom-class ${(this.props || {}).className || ''}`
    };
    delete this.date_picker_props.dark;
    delete this.date_picker_props.DatePicker;
    delete this.date_picker_props.DateEditor;
    delete this.date_picker_props.MonthView;
    delete this.date_picker_props.YearView;
    delete this.date_picker_props.DecadeView;
    delete this.date_picker_props.HistoryView;
    delete this.date_picker_props.DateFormatInput;
    delete this.date_picker_props.DateFormatSpinnerInput;
    delete this.date_picker_props.TransitionView;
    delete this.date_picker_props.MultiMonthView;
    delete this.date_picker_props.NavBar;
    delete this.date_picker_props.Footer;
    delete this.date_picker_props.Clock;
    delete this.date_picker_props.ClockInput;
    delete this.date_picker_props.DateField;
    delete this.date_picker_props.Calendar;
    delete this.date_picker_props.TimePicker;
    delete this.date_picker_props.TimeInput;

    return (
      this.props.DatePicker ? (
        <ReactDatePicker {...this.date_picker_props} />
      ) : this.props.DateEditor ? (
        <DateEditor {...this.date_picker_props} />
      ) : this.props.MonthView ? (
        <MonthView {...this.date_picker_props} />
      ) : this.props.YearView ? (
        <YearView {...this.date_picker_props} />
      ) : this.props.DecadeView ? (
        <DecadeView {...this.date_picker_props} />
      ) : this.props.HistoryView ? (
        <HistoryView {...this.date_picker_props} />
      ) : this.props.DateFormatInput ? (
        <DateFormatInput {...this.date_picker_props} />
      ) : this.props.DateFormatSpinnerInput ? (
        <DateFormatSpinnerInput {...this.date_picker_props} />
      ) : this.props.TransitionView ? (
        <TransitionView {...this.date_picker_props} />
      ) : this.props.MultiMonthView ? (
        <MultiMonthView {...this.date_picker_props} />
      ) : this.props.NavBar ? (
        <NavBar {...this.date_picker_props} />
      ) : this.props.Footer ? (
        <Footer {...this.date_picker_props} />
      ) : this.props.Clock ? (
        <Clock {...this.date_picker_props} />
      ) : this.props.ClockInput ? (
        <ClockInput {...this.date_picker_props} />
      ) : this.props.DateField ? (
        <DateField {...this.date_picker_props} />
      ) : this.props.Calendar ? (
        <Calendar {...this.date_picker_props} />
      ) : this.props.TimePicker ? (
        <TimePicker {...this.date_picker_props} />
      ) : this.props.TimeInput ? (
        <TimeInput {...this.date_picker_props} />
      ) : <ReactDatePicker {...this.date_picker_props} />
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/browser/components/ui/date-picker.js